// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__gsJlf","left":"InfoRow_left__3rhxo"};